import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { TranslationProvider } from '@ibk/shared-translation';
import { contabilidadeDigitalTranslations } from '../../translations';
import ConsentFeedback from './ConsentFeedback';
export const ConsentFeedbackRouter = () => {
    return (_jsx(TranslationProvider, { translations: contabilidadeDigitalTranslations, defaultLanguage: 'pt-BR', children: _jsx(Routes, { children: _jsx(Route, { path: '/', element: _jsx(ConsentFeedback, {}) }) }) }));
};
export default ConsentFeedbackRouter;
